import "jQuery";
import {getScrollBarWidth} from './utils';
import {breakpoints} from './responsive';

'use strict';

(function($) {

    function getDocumentOffsetTop(elem) {
        if(elem.offsetParent === null) {
            return null;
        }
        var box = elem.getBoundingClientRect();
        var body = document.body;
        var docEl = document.documentElement;
        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var top  = box.top +  scrollTop - clientTop;
        return Math.round(top);
    }

    function textNodesUnder(node){
        var all = [];
        for (node=node.firstChild;node;node=node.nextSibling){
            if (node.nodeType==3) {
                if(node.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim() !== '') {
                    all.push(node);
                }
            }
            else all = all.concat(textNodesUnder(node));
        }
        return all;
    }

    function updateNetworkLinksPosition() {
        // let $wrap = $('.network-links-wrapper');
        // let $links_wrap = $('.network-links', $wrap);
        // $wrap.addClass('active');
        // let pos_right = $(window).outerWidth(true) - $links_wrap.offset().left;
        // $links_wrap.css('width', pos_right - getScrollBarWidth() + 'px');
        // $wrap.removeClass('active');
    }

    function setFloatingLogoPosition() {
        let first_text_position = 99999;
        $('.page-content-main-container > .row > .entry-content').each(function() {
            let textNodes = textNodesUnder(this);
            textNodes.forEach(function(node) {
                let offsetTop = getDocumentOffsetTop(node.parentNode);
                if(offsetTop > 0 && offsetTop < first_text_position) {
                    first_text_position = offsetTop;
                }
            });
        });
        $('.floating-logo').css('top', first_text_position + 'px').show(0);
    }

    function initMobileMenu() {
        $('.navbar-toggler').click(function() {
            let $target = $($(this).data('target'));
            $target.toggleClass('show');
        });
        $('.mobile-menu').each(function() {
            let $mobile_menu = $(this);
            let $network_links = $('#masthead .network-links-wrapper .network-links').clone();
            let $language_links = $('#masthead .language-switcher').clone();
            $network_links.removeClass().addClass('sub-menu').appendTo($('.open-network-links', $mobile_menu));
            $language_links.removeClass().addClass('sub-menu').appendTo($('.open-language-links', $mobile_menu));

            $('.menu-item.open-network-links > a, .menu-item.open-language-links > a', $mobile_menu).click(function(e) {
                e.preventDefault();
                $(this).closest('.menu-item').find('.sub-menu').toggleClass('active');
            });
        });
    }

    $(document).ready(function() {

        breakpoints.init();

        $('.network-links-wrapper').each(function() {
            let $wrap = $(this);
            updateNetworkLinksPosition();
            $('.open-network-links', $wrap).on('click', function(e) {
                e.preventDefault();
                $wrap.toggleClass('active');
            });
            $('body').on('click', function(e) {
                let $target = $(e.target);
                if(!$wrap.hasClass('active')) {
                    return;
                }
                if($target.is('.network-links-wrapper') || $target.closest('.network-links-wrapper').length) {
                    return;
                }
                $wrap.removeClass('active');
            });
        });

        $('.main-menu .menu-item a').on('click', function(e) {
            if(breakpoints.is('bp_min_md')) {
                $('.menu-headers .menu-item-header').removeClass('active');
                let menu_id_target = $(this).data('menu-id');
                let $menu_header = $('.menu-headers .menu-item-header.menu-id-' + menu_id_target)
                if(menu_id_target === undefined || $menu_header.length <= 0) {
                    return true;
                }
                e.preventDefault();
                e.stopPropagation();
                $menu_header.addClass('active');
            }
        });
        $('.menu-headers .menu-item-header').each(function(e) {
            let $wrap = $(this);
            $('body').on('click', function(e) {
                let $target = $(e.target);
                if(!$wrap.hasClass('active')) {
                    return;
                }
                if($target.is('.menu-item-header') || $target.closest('.menu-item-header').length) {
                    return;
                }
                $wrap.removeClass('active');
            });
        });
        $('.close-menu-header a').on('click', function(e) {
            e.preventDefault();
            $('.menu-headers .menu-item-header').removeClass('active');
        });

        window.onscroll = function(e) {
            if(!$('body').hasClass('auto-scrolling')) {
                let isScrollUp = this.oldScroll > this.scrollY;
                this.oldScroll = this.scrollY;
                if(isScrollUp && this.scrollY > 1) {
                    $('.site-header.sticky-header').addClass('active');
                    $('body').addClass('sticky-header-active');
                } else {
                    $('.site-header.sticky-header').removeClass('active');
                    $('body').removeClass('sticky-header-active');
                }
            }
        }
    });
    $(window).load(function() {
        updateNetworkLinksPosition();
        setFloatingLogoPosition();
        initMobileMenu();
    });
})( jQuery );